export const zh = {
  nav: {
    features: "功能",
    stats: "数据",
    pricing: "价格",
    gallery: "界面",
    contacts: "联系",
    about: "关于我们",
    faq: "常见问题",
    auth: "授权登录",
    logout: "退出登录"
  },
  hero: {
    badge: "版本 2.0.1.0 • 稳定版",
    title: "Telegram PRIME",
    subtitle: "终极 Telegram 营销自动化工具。一键实现强大群发、拉人、采集、用户名检测和自动回复。",
    ctaStart: "免费开始使用",
    ctaPricing: "查看价格方案",
    ctaInterface: "界面演示"
  },
  stats: {
    title: "我们的社区与成就",
    onlineUsers: "在线活跃用户",
    reviews: "各大论坛评价数",
    community: "论坛社区活跃度",
    invites: "累计拉人次数",
    messages: "累计群发消息数"
  },
  features: {
    title: "强大的自动化功能",
    subtitle: "Telegram PRIME 包含您在 Telegram 中进行全面营销和自动化所需的一切功能",
    showAll: "显示全部功能",
    hideAll: "隐藏部分功能",
    items: {
      relogin: {
        title: "账号登录重连",
        desc: "支持同时从不同位置连接并轻松使用 Telegram 账号。"
      },
      s2td: {
        title: "Session 转 Tdata",
        desc: "将 Session 文件转换为 TData 格式以在 Telegram Desktop 上使用。"
      },
      td2s: {
        title: "Tdata 转 Session",
        desc: "将您的 TData 配置文件转换为 Session 文件以便在我们的软件中使用。"
      },
      warmup: {
        title: "AI 智能群聊活跃 (暖号)",
        desc: "将账号拉入群组，设定对话伙伴与话题，模拟真实群聊活跃度。"
      },
      vtope: {
        title: "vTope 自动化任务",
        desc: "连接到庞大的 vTope 网络，通过自动浏览、表态反应和关注赚取收益。"
      },
      automsg: {
        title: "自动私信新成员",
        desc: "在潜在客户进入群组的第一时间，自动发送消息进行精准拦截营销。"
      },
      autolike: {
        title: "频道自动点赞表态",
        desc: "使您的账号总能抢先在频道发布新帖子时自动进行点赞和表态反应。"
      },
      autocomment: {
        title: "频道自动抢沙发评论",
        desc: "抢占最受关注的第一条评论，让您的广告和声音被所有人看见！"
      },
      checker: {
        title: "用户名有效性检测",
        desc: "快速批量检测和过滤 Telegram 用户名，为后续群发做准备。"
      },
      unblock: {
        title: "账号自助申诉解封",
        desc: "使用独特的申诉理由自动提交解封申请，延长账号的使用寿命。"
      },
      admininvite: {
        title: "管理员辅助拉人",
        desc: "通过指派的群组管理员添加成员，有效防止群组本身被封禁。"
      },
      reports: {
        title: "批量自动投诉工具",
        desc: "自动向违规或竞争对手的 Telegram 群组、频道或机器人发送批量投诉。"
      },
      randomizer: {
        title: "智能文本混淆 2.0",
        desc: "融合传统 Spin-tax 与现代 AI，实现群发消息的高度原创性和可读性。"
      },
      stories: {
        title: "故事发布管理器",
        desc: "在 Telegram 账号上批量发布故事，自动浏览故事并提升频道等级。"
      },
      interceptor: {
        title: "实时消息监听拦截",
        desc: "实时捕获并转发指定账号的收件箱消息到您的特定机器人或账户。"
      },
      chatcloner: {
        title: "群组克隆专家",
        desc: "一键克隆任何活跃群组，包括其结构、设计以及模拟历史用户消息。"
      },
      webchat: {
        title: "网页端账号管理面板",
        desc: "无需转换 TData。直接在浏览器界面实时查看和管理您的账号。"
      },
      offerphoto: {
        title: "批量推荐广告头像",
        desc: "向目标用户批量推荐包含您广告文案的头像图片，提升曝光率。"
      },
      chancloner: {
        title: "频道实时同步克隆",
        desc: "实时克隆目标频道（在新帖子发布时）或一键搬运历史所有帖子。"
      },
      autoinvite: {
        title: "自动监控竞品拉人",
        desc: "监控竞品群组，自动将新加入的活跃成员拉入到您自己的群组中。"
      }
    }
  },
  details: {
    sectionTitle: "为什么选择 TELEGRAM PRIME?",
    block1: {
      title: "Telegram 营销的终极引擎",
      p1: "今天就加入数字化推广革命！",
      p2: "将广告消息直接投递到潜在客户的手机上，支持定向用户、手机号列表或整个群组的成员。",
      p3: "创意无界：支持完整的文本格式美化，以及自然人声语音条发送功能。"
    },
    block2: {
      title: "高效、低成本、海量曝光",
      p1: "Telegram 群发是效率最高的网络喇叭。使用 Telegram PRIME 助您开展低成本的营销推广。",
      p2: "智能过滤账号列表，只保留最活跃、意图最真实的真人用户。"
    },
    block3: {
      title: "精准数据采集与深度分析",
      p1: "从公开或私密群组、帖子评论区以及对话历史中提取目标受众。",
      p2: "基于自定义活跃度过滤器和关键词匹配，彻底清除死号与机器人。"
    }
  },
  pricing: {
    title: "价格方案与模块",
    subtitle: "选择符合您业务推广需求的模块和伴随服务",
    tabModules: "核心模块授权",
    tabThirdParty: "辅助实用工具",
    tabPartners: "合作伙伴服务",
    buyCrypto: "加密货币购买",
    buyCard: "银行卡购买",
    askQuestion: "咨询客服",
    eternal: "终身使用授权",
    from: "起",
    modules: {
      cloner: {
        title: "频道克隆模块",
        price: "100 $",
        f1: "终身授权 - 100 美元",
        f2: "实时频道复制搬运",
        f3: "过滤屏蔽敏感词汇",
        f4: "自动替换广告链接",
        f5: "多线程高效并发"
      },
      interceptor: {
        title: "消息监听拦截模块",
        price: "100 $",
        f1: "终身授权 - 100 美元",
        f2: "同时监听监控多个账号",
        f3: "实时群聊关键词检测",
        f4: "自动转发意向线索到您的机器人",
        f5: "高级自定义触发词设置"
      },
      warmup: {
        title: "账号智能养号模块",
        price: "150 $",
        f1: "终身授权 - 150 美元",
        f2: "全自动模拟日常会话",
        f3: "AI (ChatGPT) 生成拟真脚本",
        f4: "模拟真人在群聊中日常互动",
        f5: "打字延迟与操作频次可调"
      }
    },
    thirdParty: {
      checker: {
        title: "手机号注册检测器",
        price: "40 $",
        desc: "扫描手机号列表是否注册 Telegram 并导出其 ID、Premium 状态和用户名。"
      },
      converters: {
        title: "账号格式转换器",
        price: "29 $",
        desc: "在 Session、Tdata、JSON、AuthKey 等格式之间互转，并支持重新授权验证。"
      },
      manager: {
        title: "Web-Telegram 矩阵管理器",
        price: "40 $",
        desc: "通过网页端面板管理多账户，内置任务计划程序和独立的指纹环境。"
      }
    },
    partners: {
      vps: {
        title: "云 VPS 服务器",
        price: "14 $ / 月",
        desc: "匿名 Windows/Linux VPS，经过优化，完美兼容托管您的 TG Prime 软件。"
      },
      redirect: {
        title: "Stealth 防封防洪跳转链接",
        price: "15 $ / 月",
        desc: "缩短和伪装网址以避免屏蔽，绑定自定义域名并查看实时点击分析。"
      },
      proxies: {
        title: "高品质代理 IP",
        price: "7.5 $ / 月",
        desc: "Mobile、Residential 和 Datacenter SOCKS5/HTTP 静态与动态代理。"
      }
    }
  },
  about: {
    title: "关于我们",
    subtitle: "让 Telegram 自动化变得简单高效的团队",
    lead: "Telegram PRIME 是销售 Telegram Prime 授权密钥和扩展模块的官方平台。",
    story: "我们在 Telegram 营销领域深耕超过 5 年，将所需的全部工具整合到一个生态系统中。我们的目标是为套利者、社交媒体专家和业务所有者提供可靠的软件、透明的价格和快速的支持。每个密钥都在个人后台中激活，更新会定期发布并对所有用户免费。",
    value1: {
      title: "官方密钥",
      desc: "通过安全的个人后台直接购买 Telegram Prime 许可证，无中间商和加价。"
    },
    value2: {
      title: "全天候支持",
      desc: "我们的团队通过 Telegram 和工单系统帮助您完成激活、模块设置和 HWID 绑定。"
    },
    value3: {
      title: "定期更新",
      desc: "Telegram 不断变化，因此我们会发布更新和修复，以确保所有功能稳定运行。"
    },
    value4: {
      title: "专业社区",
      desc: "加入用户交流群，在这里大家分享案例、新方案并互相帮助使用软件。"
    },
    tag: "官方经销商",
    stat1: { label: "市场年限" },
    stat2: { label: "模块数量" },
    stat3: { label: "技术支持" },
    ctaTitle: "还有问题？",
    ctaText: "请给我们发送邮件 - 我们将帮助您选择模块、激活和设置。",
    ctaButton: "邮件"
  },
  faq: {
    title: "常见问题",
    subtitle: "关于购买、激活和使用 Telegram Prime 最常见问题的解答",
    q1: "Telegram Prime 是什么？为什么需要密钥？",
    a1: "Telegram Prime 是一款综合性 Telegram 营销自动化软件：群发、拉人、采集、克隆等功能一应俱全。许可证密钥可让您访问个人后台和所选模块。",
    q2: "如何购买 Telegram Prime 密钥？",
    a2: "选择适合的套餐或模块，点击购买并使用加密货币付款。付款确认后，密钥将立即出现在您的个人后台中。",
    q3: "演示版、月付版和永久版密钥有什么区别？",
    a3: "演示版密钥为期 3 天，适合测试。月付版密钥可使用 30 天。永久版密钥提供基础许可证的终身访问权限和免费更新。",
    q4: "如果我更换了电脑或硬件怎么办？",
    a4: "个人后台提供 HWID 重置功能，可将已激活的密钥转移到新电脑。演示版密钥不支持重置。",
    q5: "购买密钥后可以添加模块吗？",
    a5: "可以，任何模块都可以在个人后台单独购买，购买后会自动绑定到您当前的密钥并激活。",
    q6: "支持哪些付款方式？",
    a6: "我们仅接受加密货币。付款详情将在个人后台的结账页面显示。",
    q7: "购买密钥后可以退款吗？",
    a7: "数字密钥和模块一旦激活概不退款。建议在购买前使用免费演示期。",
    q8: "在哪里可以获得帮助？",
    a8: "请通过在线聊天联系我们 - 平均回复时间从几分钟到几小时不等。",
    q9: "可以单独购买模块而不买核心程序吗？",
    a9: "可以，任何模块都可以单独购买。如果您只需要特定功能，则无需购买基础许可证。模块在个人后台激活并绑定到您的 HWID。"
  },
  auth: {
    login: "登录",
    register: "注册",
    email: "电子邮箱",
    password: "密码",
    username: "用户名",
    confirmPassword: "确认密码",
    submitLogin: "登录授权",
    submitRegister: "创建账户",
    noAccount: "还没有账户？",
    haveAccount: "已有账户？",
    title: "Telegram Prime 面板授权",
    close: "关闭",
    successMsg: "授权登录成功！",
    welcome: "欢迎来到客户控制台！",
    captchaRequired: "请确认您不是机器人。",
    or: "或",
    googleLogin: "使用 Google 登录",
    fillAllFields: "请填写所有字段。",
    passwordMismatch: "两次输入的密码不一致！",
    passwordWeak: "密码太简单！",
    registerSuccess: "注册成功！请登录。",
    passwordStrengthWeak: "弱",
    passwordStrengthMedium: "中",
    passwordStrengthStrong: "强",
    errorUnknown: "发生错误",
    verifyTitle: "确认邮箱",
    verifyIntro: "我们已将 6 位验证码发送至 {email}。请输入验证码完成注册。只有在确认后才会创建账户。",
    verifyLoginTitle: "确认登录",
    verifyLoginIntro: "检测到来自新 IP 地址的登录。我们已将验证码发送至 {email}。请输入验证码以确认登录。",
    codeLabel: "验证码",
    codePlaceholder: "6 位验证码",
    confirmCode: "确认",
    resendCode: "重新发送验证码",
    resendIn: "{seconds} 秒后可重新发送",
    changeEmail: "返回",
    codeRequired: "请输入验证码。",
    devCodeNotice: "开发模式（已停用邮件发送），您的验证码：{code}"
  },
  gallery: {
    title: "简易便捷的用户界面",
    subtitle: "预览 Telegram PRIME 控制面板和设置模块的实际截图"
  },
  footer: {
    desc: "Telegram PRIME - 专为 Telegram 平台设计的引流获客与营销自动化软件。版权所有。",
    community: "加入我们的社区",
    support: "技术支持服务时间：周一至周五 08:00 - 20:00 (GMT+2)。"
  },
  dashboard: {
    download: "下载 Telegram Prime",
    title: "系统参数",
    modulesTitle: "组件架构管理",
    newsTitle: "系统日志更新",
    license: "我的授权",
    shop: "模块商店",
    changelog: "更新日志",
    referral: "推荐系统",
    faq: "常见问题",
    keyInfo: "许可证密钥信息",
    activated: "已激活",
    notActivated: "未激活",
    hwidLinked: "已绑定此电脑",
    hwidFree: "未绑定 / 已重置",
    resetHwid: "重置硬件绑定 (HWID Reset)",
    activatePc: "在此电脑上激活",
    activeComponents: "已激活组件",
    installed: "已购买",
    buy: "购买",
    select: "选择",
    free: "免费",
    activateFree: "免费激活",
    linkKeyFirst: "错误！请先绑定密钥。",
    selectLicensePlan: "选择套餐以生成许可证密钥：",
    demoPeriod: "3天",
    monthlyPeriod: "30天",
    permanentPeriod: "永久",
    payWithCrypto: "用加密货币支付",
    transaction: "安全结账请求",
    selectLicenseType: "选择许可证类型",
    billingFor: "计费目标:",
    abort: "中止操作",
    blocked: "已锁定",
    expired: "已过期",
    licenseKey: "许可证密钥",
    licenseType: "类型",
    expiresAt: "过期时间",
    activeModulesCount: "激活模块数",
    active: "已激活",
    lifetime: "永久",
    deleteKey: "删除密钥",
    upgradeToPermanent: "升级到永久版",
    upgradeToMonthly: "升级到月付版",
    extendLicense: "续期许可证",
    licenseBlockedContactSupport: "许可证已锁定。请联系客服。",
    noLicenseMessage: "您还没有激活的许可证。请选择套餐开始使用。",
    buyLicenseOrDemo: "购买许可证 / 试用演示版",
    ready: "就绪",
    noActiveModules: "暂无激活模块",
    copyKey: "复制密钥",
    copied: "已复制！",
    referralTitle: "推荐系统",
    referralCode: "您的推荐码",
    referralBalance: "推荐余额",
    referralHowItWorks: "运作方式：",
    referralStep1: "复制您的个人推荐码。",
    referralStep2: "将推荐码分享给朋友或用于广告。",
    referralStep2Link: "分享您的推荐链接 — 所有访问都会自动统计。",
    referralStep3: "购买者购买付费密钥可获得 {percent}% 折扣。",
    referralStep4: "您将获得购买金额 {percent}% 的奖励。",
    referralDemoInfo: "{percent}% 折扣仅适用于付费密钥。演示密钥不可使用推荐码。",
    referralLinkLabel: "您的推荐链接",
    referralLinkCopied: "推荐链接已复制！",
    referralLinkHint: "通过此链接访问的每位用户都会自动获得您的推荐码，无需输入优惠码。",
    referralClicks: "链接访问次数",
    faqTitle: "常见问题",
    faqEmpty: "常见问题暂时不可用。",
    referralTagline: "与 Telegram Prime 一起赚钱 ❤️",
    applyReferralCode: "应用推荐码",
    referralCodePlaceholder: "输入推荐码",
    referralHint: "购买前输入推荐码，以获得付费密钥的折扣。",
    apply: "应用",
    referralCodeApplied: "推荐码已应用 - {percent}% 折扣",
    referralCodeInvalid: "推荐码无效",
    referralCodeCopied: "推荐码已复制！",
    applyPromoCode: "我有优惠码",
    promoCodePlaceholder: "输入优惠码",
    promoHint: "购买前输入优惠码以获得额外折扣。优惠码与推荐码折扣可叠加。",
    promoCodeApplied: "优惠码已应用 - {percent}% 折扣",
    promoCodeInvalid: "优惠码不存在或已失效",
    referralTransactions: "推荐收益记录",
    referralEarning: "收益",
    referralNoTransactions: "暂无论推荐收益。",
    messages: {
      demoResetDisabled: "演示密钥不支持硬件重置",
      keyNotBound: "密钥未绑定到设备",
      licenseExpired: "许可证已过期。请先续期。",
      licenseBlocked: "许可证已锁定",
      hwidResetSuccess: "硬件绑定已成功重置！",
      tooManyRequests: "请求过于频繁。请等待24小时。",
      hwidResetFailed: "硬件重置失败",
      networkError: "网络错误",
      confirmDeleteKey: "您确定要删除密钥吗？此操作无法撤销。",
      keyDeletedSuccess: "密钥已成功删除！",
      keyDeleteFailed: "删除密钥失败",
      redirectingToPayment: "正在重定向到支付页面...",
      upgradeRequestSent: "升级请求已发送！",
      upgradeRequestFailed: "发送升级请求失败",
      extensionRequestSent: "续期请求已发送！",
      extensionRequestFailed: "发送续期请求失败",
      demoModulesAdded: "模块已免费添加到演示密钥",
      demoModulesFailed: "无法添加模块到演示密钥",
      copyKeySuccess: "密钥已复制到剪贴板",
      copyKeyFailed: "无法复制密钥"
    }
  },
  license: {
    success: {
      demo_activated: "演示密钥激活成功"
    }
  },
  cabinetFaq: {
    subtitle: "关于许可证和模块的常见问题",
    q1: "如何激活购买的密钥？",
    a1: "付款后，密钥将出现在个人后台的“我的授权”标签页中。点击“在此电脑上激活”以绑定 HWID。",
    q2: "什么是 HWID，为什么需要它？",
    a2: "HWID 是您电脑的唯一标识符。它保护密钥不被转让给第三方。激活时会自动绑定。",
    q3: "如果我更换了电脑，如何重置 HWID？",
    a3: "在个人后台的“我的授权”标签页中，点击“重置硬件绑定 (HWID Reset)”。每 24 小时最多重置一次。演示密钥不支持重置。",
    q4: "如何购买额外模块？",
    a4: "进入“模块商店”标签页，选择模块并点击“购买”。付款后，模块将自动绑定到您的密钥。",
    q5: "一个密钥可以在多台电脑上使用吗？",
    a5: "不可以，一个密钥同时只能在一台电脑上激活。如需转移，请使用 HWID 重置。",
    q6: "在哪里下载 Telegram Prime？",
    a6: "下载链接位于个人后台顶部 --“下载 Telegram Prime”按钮。",
    q7: "如何应用推荐码？",
    a7: "个人后台中有“推荐系统”模块。在购买付费密钥前输入推荐码，折扣将自动应用。",
    q8: "如果许可证过期了怎么办？",
    a8: "在“我的授权”标签页中，选择“续期许可证”或“升级到永久版”。付款后将恢复访问。",
    q9: "如果密钥被锁定了怎么办？",
    a9: "如果您看到“已锁定”状态，请联系技术支持。锁定可能与违反使用规则有关。",
    q10: "为什么付款后模块没有显示？",
    a10: "请在个人后台检查付款状态。如果款项已扣除但模块未添加，请联系支持并提供交易号。",
    supportTitle: "没找到答案？",
    supportText: "请通过在线聊天联系我们 - 我们将帮助您解决激活、模块和付款问题。",    emailBtn: "邮件",
    telegramBtn: "Telegram"
  },
  modules: {
    module_1: {
      name: "聊天克隆器",
      features: [
        "永久访问 - 345 $",
        "聊天历史收集",
        "账号准备",
        "消息编辑器，按需编辑历史",
        "按间隔或按原始方式发布历史",
        "获取竞争对手群组副本",
        "不支持退款"
      ]
    },
    module_2: {
      name: "举报器",
      features: [
        "永久访问 - 175 $",
        "能够封锁竞争对手频道",
        "能够封锁竞争对手群组",
        "能够封锁TG机器人",
        "通过邀请到聊天进行投诉",
        "多线程工作",
        "不支持退款"
      ]
    },
    module_3: {
      name: "频道克隆器",
      features: [
        "永久访问 - 105 $",
        "自主频道填充",
        "替换关键词和链接",
        "克隆旧帖子",
        "排除不需要的内容并添加自己的内容",
        "多线程工作以快速获得结果",
        "不支持退款"
      ]
    },
    module_4: {
      name: "消息拦截器",
      features: [
        "永久访问 - 100 $",
        "监控账号上发生的一切",
        "实时聊天关键词搜索",
        "多线程工作",
        "将请求转发到您需要的地方（频道、机器人或账号）",
        "使用关键词或短语",
        "不支持退款"
      ]
    },
    module_5: {
      name: "账号预热器",
      features: [
        "永久访问 - 150 $",
        "完全自动化的模块操作",
        "通过大量自动执行的动作进行预热",
        "管理正在执行的任务数量",
        "通过AI实现文本唯一化",
        "多线程工作，可配置操作间延迟",
        "不支持退款"
      ]
    }
  },
  news: {
    error: "加载更新失败",
    noUpdates: "暂无可用更新",
    loading: "正在加载更新...",
    latestUpdate: "最新更新",
    version: "版本",
    update: "更新"
  }
};
